import mgt from "./modules/mgt";
import portal from "./modules/portal";
export default [{
  path: "/",
  meta: {
    auth: false
  },
  component: () => import(/* webpackChunkName: "Login" */"@/views/Login.vue")
}, ...portal, ...mgt];